import React from 'react'
import CTAButton from '../CTA/cta'
import Markdown from '../Markdown/markdown'
import './content-grid.scss'

class ContentGrid extends React.Component {

  state = {}

  componentDidMount() {
    const styleOption = this.props.content.style === 'team-page' ? 'grid-team-page' : 'grid-standard'
    this.setState({styleOption})
  }

  renderGridItems(gridItems, columns) {

    let numCols = columns ? columns : 3
    
    if (gridItems) {
      return (
        <div className="grid">
          {gridItems.map((item, i) => { return <div className={`grid-item grid-col-${numCols}`} key={i}>{this.renderItem(item)}</div> })}
        </div>
      )
    } else {
      return null
    }
    
  }

  renderItem(item) {
    if (item) {
      const imageUrl = item.image && item.image[0].file && item.image[0].file.url ? item.image[0].file.url : null
      const bgColor = item.backgroundColor ? {backgroundColor: item.backgroundColor} : {}
      const textAlign = this.props.content.textAlign ? this.props.content.textAlign : ''

      return (
        <React.Fragment>
          {imageUrl ? <div className={`grid-image-wrapper ${this.state.styleOption}-image`} style={bgColor}>
            <img src={imageUrl} className={ `grid-image` }/>
          </div>: null}
          <div className={`grid-content-wrapper ${this.state.styleOption}-content`} style={{textAlign, ...(imageUrl && this.state.styleOption !== 'grid-team-page' ? {padding: '0 1.5rem', marginTop: '-1.25rem'} : {padding: '0 1rem'})}}>
            {item.heading ? <h4 className={`grid-item-heading`} style={{textAlign}}>{item.heading}</h4> : null}
            {item.subheading ? <h6 className={`grid-item-subheading`} style={{textAlign}}>{item.subheading}</h6> : null}
            {item.body && item.body.body ? <div className={`grid-item-body`}><Markdown content={item.body.body} /></div> : null}
          </div>
        </React.Fragment>
      )
    } else {
      return null
    }
  }

  render() {
    const {gridHeading, gridItems, ctaButtons, columns} = this.props.content

    return (
      <div className="grid-container" data-cy="content-grid">
        {gridHeading ? <h1 className={`grid-heading ${this.state.styleOption}-heading`}>{gridHeading}</h1> : null}

        {this.renderGridItems(gridItems, columns)}
        {ctaButtons ? <div className="grid-cta">
          {ctaButtons.map((cta, i) => {
            return <CTAButton type={i > 0 ? 'secondary' : 'primary'} title={cta.title} url={cta.url} key={i} lang={this.props.lang} style={cta.style}/>
          })}
        </div> : null}
      </div>
    )
  }
}

export default ContentGrid


// WEBPACK FOOTER //
// ./src/components/ContentGrid/content-grid.js